import { PhoneFormatPipe } from '@/src/pipes/phone-format-pipe';
import { AuthenticationService } from '@/src/services/authentication.service';
import { MasterService } from '@/src/services/master.service';
import { CommonModule } from '@angular/common';
import { Component, input, output, signal, Signal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { InputText } from "primeng/inputtext";

@Component({
  selector: 'components-member-detail',
  standalone: true,
  imports: [TranslateModule, InputText, CommonModule, PhoneFormatPipe],
  templateUrl: './member-detail.html',
  styleUrl: './member-detail.css',
})
export class MemberDetail {
  open = input<Signal<boolean>>();
  member_no = input<string>('');
  close = output<void>();
  data = signal<any | null>(null);

  constructor(private auth: AuthenticationService, private masterService: MasterService) { }
  ngOnInit() {
    this.getDetail();
  }

  onClose() {
    this.close.emit();
  }

  getDetail() {
    const param = {
      P_HQ_CD: this.auth.getHQCD(),
      P_STR_CD: this.auth.getStrCd(),
      P_MEMBER_NO: this.member_no()
    }
//SP_STR_GET_MEMBER_INFO
    this.masterService.excute_sp('6a839c37-298d-11f1-9014-00155d001e02', param).subscribe((res: any) => {
      if (res?.isOK) {
        this.data.set(res?.result?.dataRes[0]?.rows[0]);
      }
    })
  }
}
